import Vue from 'vue';
import axios from 'axios';

var restModel = 'googleplaces';
var baseUrl = process.env.apiUrl;
var httpConfig = function() { return {headers: {'x-auth-token': localStorage.getItem('accessToken')}} };

export default {
  textSearch(searchTerm, lat, lng) {
    let data = { searchTerm };

    if(lat && lng) {
      data.lat = lat;
      data.lng = lng;
    }

    return axios.post(baseUrl + '/' + restModel + '/textsearch', data, httpConfig());
  },

  nearbySearch(searchTerm, lat, lng) {
    let data = { searchTerm, lat, lng };
    return axios.post(baseUrl + '/' + restModel + '/nearbysearch', data, httpConfig());
  },

  getPlaceDetails(placeId) {
    return axios.post(baseUrl + '/' + restModel + '/getplacedetails', { placeId: placeId }, httpConfig());
  }
}



// WEBPACK FOOTER //
// ./src/services/GooglePlacesService.js